import { AuthGuard } from './guards/auth.guard';
import { RegGuard } from './guards/reg.guard';
import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
    canActivate: [AuthGuard, RegGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule),
    canActivate: [RegGuard]
  },
  {
    path: 'device-setup',
    loadChildren: () => import('./pages/device-setup/device-setup.module').then( m => m.DeviceSetupPageModule)
  },
  {
    path: 'validate',
    loadChildren: () => import('./pages/validate/validate.module').then(m => m.ValidatePageModule)
  },
  {
    path: 'send',
    loadChildren: () => import('./pages/send/send.module').then( m => m.SendPageModule)
  },
  {
    path: 'product-payment',
    loadChildren: () => import('./pages/product-payment/product-payment.module').then( m => m.ProductPaymentPageModule)
  },
  {
    path: 'product-sale',
    loadChildren: () => import('./pages/product-sale/product-sale.module').then( m => m.ProductSalePageModule)
  },
  {
    path: 'batch-transactions',
    loadChildren: () => import('./pages/batch-transactions/batch-transactions.module').then( m => m.BatchTransactionsPageModule)
  },


];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
